import {
  ComponentType,
  lazy,
  LazyExoticComponent,
  Suspense,
  PropsWithChildren,
} from 'react';

export const suspended =
  <T,>(
    Component: LazyExoticComponent<(props: T) => JSX.Element>,
    Loader: () => JSX.Element
  ) =>
  (props: T): JSX.Element =>
    (
      <Suspense fallback={<Loader/>}>
        {/* somehow says that can't pass those props, even though they are exactly what `Component` expects */}
        {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
        {/* @ts-ignore */}
        <Component {...props} />
      </Suspense>
    );

export const lazyComponent = <T extends ComponentType>(
  _import: () => Promise<{ default: T } | T>
): LazyExoticComponent<T> =>
  lazy(async () => {
    const imported = await _import();
    return 'default' in imported ? imported : { default: imported };
  });

export const suspendedLazy = <
  P,
  T = (props: PropsWithChildren<P>) => JSX.Element
>(
  _import: () => Promise<{ default: T } | T>,
  loader?: () => JSX.Element
  /* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
  /* @ts-ignore */
): T => suspended(lazyComponent(_import), loader);
